import React, { Component } from "react";
import Modal from "react-modal";
import Accordion from "react-bootstrap/Accordion";
import { Card, Button } from "react-bootstrap";
import moment from "moment";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    position: "relative",
    padding: "0px",
  },
};

export class BusinessHoursMultiplePopup extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      expanded: "",
    };
  }

  openModal = (e) => {
    e.preventDefault();
    this.setState({ open: true });
  };

  closedModal = (e) => {
    this.setState({ open: false });
  };

  handleToggle = (value) => (e) => {
    this.setState({
      expanded: value,
    });
  };

  render() {
    const { open } = this.state;
    return (
      <React.Fragment>
        <button
          className="mb-5 border-0 bg-transparent c_red font_18_m"
          onClick={this.openModal}
          type="button"
        >
          {open ? "See less details" : "See more details"}
          {open ? (
            <i className="fa fa-chevron-up ml-3" aria-hidden="true"></i>
          ) : (
            <i className="fa fa-chevron-down ml-3" aria-hidden="true"></i>
          )}
        </button>
        <Modal
          isOpen={open}
          onRequestClose={this.closedModal}
          style={customStyles}
          className="business-hours-multiple_timing"
          contentLabel="Example Modal"
          ariaHideApp={false}
        >
          <React.Fragment>
            <div className="business-hours-multiple_timing-header">
              <h5>Timings</h5>
              <i
                className="fa fa-times"
                aria-hidden="true"
                onClick={this.closedModal}
              ></i>
            </div>
            <hr />
            <div className="business-hours-multiple_timing-header">
              <h4>Hours of Operation</h4>
              {/* <div className="timing-box-section">
                <img
                  className="img-fluid"
                  src={require("../../../../../assets/images/RightNavigationIcon/clock.svg")}
                  alt="Business Hours"
                  title="Business Hours"
                />
                <div className="timing-box-section-small">
                  <p className="time-text-paragraph">11:00 AM</p>
                  <p className="time-text-span">Opens At</p>
                </div>
              </div> */}
            </div>
            <div className="business-hours-accordion-view">
              <Accordion>
                <Card>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    eventKey="0"
                    className="accordion-box"
                    onClick={this.handleToggle("0")}
                  >
                    Monday{" "}
                    <i
                      className={
                        this.state.expanded === "0"
                          ? "fa fa-chevron-up"
                          : "fa fa-chevron-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {this.props.monday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <h4>
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </h4>
                                <h5>{day.description}</h5>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    eventKey="1"
                    className="accordion-box"
                    onClick={this.handleToggle("1")}
                  >
                    Tuesday
                    <i
                      className={
                        this.state.expanded === "1"
                          ? "fa fa-chevron-up"
                          : "fa fa-chevron-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {this.props.tuesday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <h4>
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </h4>
                                <h5>{day.description}</h5>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    eventKey="2"
                    className="accordion-box"
                    onClick={this.handleToggle("2")}
                  >
                    Wednesday
                    <i
                      className={
                        this.state.expanded === "2"
                          ? "fa fa-chevron-up"
                          : "fa fa-chevron-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {this.props.wednesday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <h4>
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </h4>
                                <h5>{day.description}</h5>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    eventKey="3"
                    className="accordion-box"
                    onClick={this.handleToggle("3")}
                  >
                    Thursday
                    <i
                      className={
                        this.state.expanded === "3"
                          ? "fa fa-chevron-up"
                          : "fa fa-chevron-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="3">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {this.props.thursday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <h4>
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </h4>
                                <h5>{day.description}</h5>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    eventKey="4"
                    className="accordion-box"
                    onClick={this.handleToggle("4")}
                  >
                    Friday
                    <i
                      className={
                        this.state.expanded === "4"
                          ? "fa fa-chevron-up"
                          : "fa fa-chevron-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="4">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {this.props.friday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <h4>
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </h4>
                                <h5>{day.description}</h5>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    eventKey="5"
                    className="accordion-box"
                    onClick={this.handleToggle("5")}
                  >
                    Saturday
                    <i
                      className={
                        this.state.expanded === "5"
                          ? "fa fa-chevron-up"
                          : "fa fa-chevron-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="5">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {this.props.saturday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <h4>
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </h4>
                                <h5>{day.description}</h5>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    eventKey="6"
                    className="accordion-box"
                    onClick={this.handleToggle("6")}
                  >
                    Sunday
                    <i
                      className={
                        this.state.expanded === "6"
                          ? "fa fa-chevron-up"
                          : "fa fa-chevron-down"
                      }
                      aria-hidden="true"
                    ></i>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="6">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {this.props.sunday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <h4>
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </h4>
                                <h5>{day.description}</h5>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </React.Fragment>
        </Modal>
      </React.Fragment>
    );
  }
}

export default BusinessHoursMultiplePopup;
